<template>
  <div>
    <label for="timeValue" class="form-label">{{ label }}</label>
    <div class="input-group">
      <input
        type="number"
        id="timeValue"
        class="form-control w-50"
        min="1"
        max="999"
        aria-label="Time value"
        v-model="timeValue"
        required
      />
      <select id="timeUnit" class="form-select w-25" aria-label="Time unit" v-model="timeUnit">
        <option value="days">Day(s)</option>
        <option value="weeks">Week(s)</option>
        <option value="months">Month(s)</option>
        <option value="years">Year(s)</option>
      </select>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TimeLimitInput',
    props: {
      label: {
        type: String,
        default: '',
      },
      value: {
        required: true,
      },
    },
    computed: {
      valueSplit() {
        return this.value ? this.value.split(' ') : null;
      },

      timeValue: {
        get() {
          return this.valueSplit && this.valueSplit.length > 1 ? this.valueSplit[0] : null;
        },
        set(value) {
          this.$emit('update:value', `${value} ${this.timeUnit}`);
        },
      },

      timeUnit: {
        get() {
          return this.valueSplit && this.valueSplit.length > 1 ? this.valueSplit[1] : null;
        },
        set(value) {
          this.$emit('update:value', `${this.timeValue} ${value}`);
        },
      },
    },
  };
</script>
